let settings;

if (process.env.NODE_ENV === "production") {
  settings = {
    time: 10000,
  };
} else {
  settings = {
    time: 100000,
    diffDebug: true,
    diffDebugTiming: true,
    diffDebugImageUpload: false
  };
}

export { settings }
